import { render, staticRenderFns } from "./Reservations.vue?vue&type=template&id=079f4f1b&scoped=true"
import script from "../script/reservations-script.js?vue&type=script&lang=js&external"
export * from "../script/reservations-script.js?vue&type=script&lang=js&external"
import style0 from "./Reservations.vue?vue&type=style&index=0&id=079f4f1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079f4f1b",
  null
  
)

export default component.exports